/**
 * @desc 获取历史实例
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<Array<defs.activiti.HistoricActivityInstanceDto>>;
export function request(
  params: API.activiti.business.historyInstanceByBusinessKey.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/business/historyInstanceByBusinessKey`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
